import React from 'react';
import HeaderSection from "../headerSection/HeaderSection";


function CulturalAdvertising(){
    return(
  <div>
  <HeaderSection></HeaderSection>
  <p>فرهنگی تبلیغاتی</p>
</div>
    )
};

export default CulturalAdvertising;